/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Price_Optional_BadgeInputs */

const es_landing_price_optional_badge = /** @type {(inputs: Landing_Price_Optional_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opcional · gratis`)
};

const gl_landing_price_optional_badge = /** @type {(inputs: Landing_Price_Optional_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opcional · de balde`)
};

const en_landing_price_optional_badge = /** @type {(inputs: Landing_Price_Optional_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional · free`)
};

/**
* | output |
* | --- |
* | "Optional · free" |
*
* @param {Landing_Price_Optional_BadgeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_price_optional_badge = /** @type {((inputs?: Landing_Price_Optional_BadgeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Price_Optional_BadgeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_price_optional_badge(inputs)
	if (locale === "en") return en_landing_price_optional_badge(inputs)
	return es_landing_price_optional_badge(inputs)
});